import React, { useEffect, useState, useRef } from "react"
import { debounce, round } from "lodash"
import { Grid, Box, TextField } from "@material-ui/core"
import { Helmet } from "react-helmet"

const PaymentPage = () => {
  const [email, setEmail] = useState<string>()
  const [amount, setAmount] = useState<number>()
  const [completed, setCompleted] = useState<boolean>(false)
  const paypalButton = useRef<HTMLDivElement>(null)
  const debounced = debounce(setAmount, 200)

  useEffect(() => {
    if (amount && email && paypalButton.current) {
      paypalButton.current!.innerHTML = ""
      ;(window as any).paypal
        .Buttons({
          createOrder: (data: any, actions: any) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    currency_code: "USD",
                    value: amount.toString(),
                  },
                },
              ],
            })
          },
          onApprove: (data: any, actions: any) => {
            return actions.order.capture().then((details: any) => {
              setCompleted(true)
            })
          },
        })
        .render("#paypal-button-container")
    }
  }, [amount, email])

  return (
    <>
      <Helmet>
        <title>Mayk Pay</title>
      </Helmet>
      <Grid
        alignItems='center'
        justify='center'
        container
        direction='column'
        style={{ height: "100%" }}
      >
        <Box>
          <Box justifyContent='center' display='flex'>
            <img src={process.env.PUBLIC_URL + "/logo.png"} alt='logo' style={{ marginBottom: 8 }} />
          </Box>
          {completed && (
            <h5 style={{ textAlign: "center" }}>Payment completed!</h5>
          )}
          {!completed && (
            <>
              <h5>Personal Information</h5>
              <TextField
                required
                label='email'
                style={{ width: "100%", marginBottom: 8 }}
                onChange={e => setEmail(e.currentTarget.value)}
              />
              <TextField
                required
                label='amount due'
                style={{ width: "100%", marginBottom: 8 }}
                type='number'
                onChange={e =>
                  debounced(round(parseFloat(e.currentTarget.value), 2))
                }
              />
              {!!amount && (
                <>
                  <h5>Payment Method</h5>
                  <Grid>
                    <div id='paypal-button-container' ref={paypalButton}></div>
                  </Grid>
                </>
              )}
            </>
          )}
        </Box>
      </Grid>
    </>
  )
}

export default PaymentPage
